"use client";

import * as React from "react";
import { BookOpen, GraduationCap, Microscope, Users } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Progress } from "@/components/ui/progress";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const skills = [{
  name: "Data Analysis & Interpretation",
  value: 90
}, {
  name: "Strategic Framework Application",
  value: 85
}, {
  name: "Financial Modeling Basics",
  value: 75
}, {
  name: "Cross-functional Collaboration",
  value: 88
}];
const experiences = [{
  id: "coursework",
  title: "Key Coursework",
  icon: BookOpen,
  content: "Completed rigorous modules in Microeconomics, Corporate Finance, and Organizational Behavior. Consistently applied theoretical frameworks to real-world business cases, developing a strong foundation for advanced strategic management."
}, {
  id: "research",
  title: "Outside Work",
  icon: Microscope,
  content: "Collaborated closely with faculty on analyzing market trends within the technology sector. Assisted in gathering, cleaning, and interpreting large datasets, contributing to preliminary findings for academic publication."
}, {
  id: "involvement",
  title: "Campus Involvement",
  icon: Users,
  content: "Active member of undergraduate consulting initiatives. Led peer teams in pro-bono advisory projects for local Ann Arbor businesses, translating classroom theory into actionable, data-driven solutions."
}];
export default function UniversityOfMichigan() {
  const {
    ref: leftColRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightColRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="university-of-michigan" className="relative w-full bg-background overflow-hidden py-20 lg:py-32">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-background to-secondary/5 pointer-events-none" />

      {}
      <div className="absolute -left-16 top-0 text-[24rem] md:text-[32rem] lg:text-[40rem] font-serif font-black text-secondary/10 select-none pointer-events-none leading-none z-0" aria-hidden="true">
        M
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          
          {}
          <div ref={leftColRef} className={`flex flex-col space-y-8 transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary/20 text-sidebar font-medium text-sm tracking-wide">
                <GraduationCap className="size-4" />
                <span>Foundation Years</span>
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-foreground tracking-tight">
                The Ann Arbor <span className="text-sidebar">Experience</span>
              </h2>
              <p className="text-muted-foreground text-lg leading-relaxed">I began my college career in the fall of 2020 directly following covid. I majored in Political Science with the intention to go to Law School. I would become very involved in campus as well as the sports teams that Ann Arbor contained.&nbsp;</p>
              <p className="text-muted-foreground text-lg leading-relaxed">My time in Ann Arbor allowed me to grow into the man and friend that I would be and also allowed me to continue my academic development.</p>
            </div>

            
          </div>

          {}
          <div ref={rightColRef} className={`transition-all duration-1000 delay-200 ease-out ${isRightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="bg-card rounded-xl shadow-lg border border-border/50 p-6 md:p-8">
              <h3 className="text-2xl font-serif font-bold text-foreground mb-6">
                Academic & Campus Highlights
              </h3>
              <Accordion type="single" collapsible className="w-full" defaultValue="coursework">
                {experiences.map((exp, i) => {
                const Icon = exp.icon;
                return <AccordionItem key={exp.id} value={exp.id} data-index={i} className="border-border">
                      <AccordionTrigger className="hover:no-underline hover:text-sidebar transition-colors">
                        <div className="flex items-center gap-3 text-left">
                          <div className="flex items-center justify-center size-8 rounded-md bg-secondary/20 text-sidebar shrink-0">
                            <Icon className="size-4" />
                          </div>
                          <span className="font-semibold text-base">{exp.title}</span>
                        </div>
                      </AccordionTrigger>
                      <AccordionContent className="text-muted-foreground leading-relaxed pt-2 pb-4 pl-11">
                        {exp.content}
                      </AccordionContent>
                    </AccordionItem>;
              })}
              </Accordion>
            </div>
          </div>

        </div>
      </div>
    </section>;
}